export interface BlogPost {
  id: string;
  title: string;
  slug: string;
  body: any | null;
  publishedDate: string;
  author: string;
  authorPhoto: string;
  featuredImage: string;
  seoTitle: string;
  seoDescription: string;
  snippet: string | null;
}

function isPreviewMode(): boolean {
  if (typeof window === "undefined") return false;
  return new URLSearchParams(window.location.search).get("preview") === "true";
}

async function callEdgeFunction(params: URLSearchParams): Promise<any> {
  const projectId = import.meta.env.VITE_SUPABASE_PROJECT_ID;
  const anonKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

  // Forward preview flag to edge function
  if (isPreviewMode() && !params.has("preview")) {
    params.set("preview", "true");
  }

  const res = await fetch(
    `https://${projectId}.supabase.co/functions/v1/contentful-blog?${params.toString()}`,
    {
      headers: {
        apikey: anonKey,
        Authorization: `Bearer ${anonKey}`,
      },
    }
  );

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Failed to fetch from blog API");
  }

  return res.json();
}

export async function fetchBlogPosts(preview?: boolean): Promise<BlogPost[]> {
  const params = new URLSearchParams({ type: "list" });
  if (preview ?? isPreviewMode()) params.set("preview", "true");
  return callEdgeFunction(params);
}

export async function fetchBlogPost(slug: string, preview?: boolean): Promise<BlogPost | null> {
  // Normalize slug: decode, trim, strip trailing slashes, lowercase
  const cleanSlug = decodeURIComponent(slug).trim().replace(/\/+$/, "").toLowerCase();
  const params = new URLSearchParams({ type: "single", slug: cleanSlug });
  if (preview ?? isPreviewMode()) params.set("preview", "true");
  return callEdgeFunction(params);
}
